/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { alpha } from "@theme-ui/color"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import { Container, Row, Col } from "components/layout"

const SupportingEachotherHeroTwo = () => {
  const data = useStaticQuery(graphql`
    query {
      hero: file(relativePath: { eq: "supporting-eachother-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box sx={{ mt: -4 }}>
      <BackgroundImage
        tag="div"
        fluid={data.hero.childImageSharp.fluid}
        backgroundColor="#fff"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: ["center", "center right"],
        }}
      >
        <Box
          sx={{
            backgroundColor: [
              alpha("secondary", 0.9),
              alpha("secondary", 0.9),
              alpha("secondary", 0),
            ],
            backgroundImage: [
              "none",
              "linear-gradient(to right, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.95) 40%, rgba(0,0,0,0) 65%)",
            ],
            color: "background",
            py: 4,
            width: "100%",
          }}
        >
          <Container wide>
            <Row>
              <Col sx={{ width: ["100%", "70%", "50%"] }}>
                <Styled.h1 sx={{ color: "background" }}>
                  Dear type 1, we are not alone
                </Styled.h1>
                <Styled.p>Dear type 1,</Styled.p>
                <Styled.p>
                  It’s hard to imagine that there was a point in my life where I
                  didn’t know who you were. As a result of your unexpected
                  arrival, I now know about you as a disease, and the community
                  you affect more than ever. Because I’m a part of it.
                </Styled.p>
                <Styled.p>
                  When I was 26 years old – overseas, away from home and my
                  family – you snuck up on me gradually. It wasn’t until I
                  booked a flight back to Calgary after losing almost 70 pounds
                  that I was officially told I would be stuck with you forever.
                </Styled.p>
                <Styled.p>
                  Today I sit here, 40 years old, writing to you as someone who
                  was once upset – even angry – at how you changed my life, but
                  now I have strong motivation to not let you slow me down.
                </Styled.p>
                <Styled.p>
                  I am constantly empowered by seeing other children with T1D
                  being so strong, and I cannot imagine being a parent to one of
                  these strong kids…this is why a cure is so important – no
                  child or family should have to go through this.
                </Styled.p>
              </Col>
            </Row>
          </Container>
        </Box>
      </BackgroundImage>
    </Box>
  )
}

export default SupportingEachotherHeroTwo
